import React, { useState } from "react";
import styled from "@emotion/styled";
import LoadingButton from "@aceso/components/buttons/loadingButton";

import { Alert as MuiAlert, Typography } from "@mui/material";
import { spacing } from "@mui/system";

import useAuth from "../../hooks/useAuth";

const Alert = styled(MuiAlert)(spacing);

const Wrapper = styled("div")`
  width: 100%;
`;

function SignIn() {
  const { signIn, isInitialized, error } = useAuth();
  const [localError, setLocalError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleAuth0Login = async () => {
    setLocalError(null);
    setLoading(true);

    try {
      await signIn();
    } catch (err) {
      console.error("Auth0 login error", err);
      setLocalError(
        err?.message || "Unable to start the Auth0 login flow. Please try again."
      );
      setLoading(false);
    }
  };

  return (
    <Wrapper>
      {(localError || error) && (
        <Alert mt={2} mb={2} severity="warning">
          {localError || error}
        </Alert>
      )}

      <Typography variant="body2" color="textSecondary" mb={3}>
        Logg inn med din konto for å fortsette til Hug.
      </Typography>

      <LoadingButton
        type="button"
        fullWidth
        loading={loading || !isInitialized}
        variant="contained"
        color="primary"
        onClick={handleAuth0Login}
      >
        Logg inn
      </LoadingButton>
    </Wrapper>
  );
}

export default SignIn;
